import React from 'react';

function ConfirmModal({ show, action, onClose, onConfirm }) {
    const actionMessages = {
        delete: {
            title: 'Confirma Exclusão',
            body: 'Tem certeza que deseja excluir este registro?',
            confirmText: 'Excluir',
            confirmClass: 'btn-danger',
            titleClass: 'text-white', // Classe para o título (vermelho)
            headerClass: 'bg-danger',
        },
        save: {
            title: 'Confirma Salvamento',
            body: 'Deseja salvar as mudanças?',
            confirmText: 'Salvar',
            confirmClass: 'btn-success',
            titleClass: 'text-white', // Classe para o título (verde)
            headerClass: 'bg-success',
        },
        continue: {
            title: 'Confirma Continuação',
            body: 'Deseja continuar para a próxima página?',
            confirmText: 'Continuar',
            confirmClass: 'btn-primary',
            titleClass: 'text-white', // Classe para o título (azul)
            headerClass: 'bg-primary',
        },
        sendAprovacao: {
            title: 'Confirma Envio',
            body: 'Deseja enviar o DFD para Aprovação?',
            confirmText: 'Enviar',
            confirmClass: 'btn-success',
            titleClass: 'text-white', // Classe para o título (azul)
            headerClass: 'bg-success',
        },
        aprova: {
            title: 'Confirma Aprovação',
            body: 'Deseja aprovar o DFD?',
            confirmText: 'Aprovar',
            confirmClass: 'btn-success',
            titleClass: 'text-white', // Classe para o título (azul)
            headerClass: 'bg-success',
        },
        reprova: {
            title: 'Confirma Reprovação',
            body: 'Deseja reprovar o DFD?',
            confirmText: 'Reprovar',
            confirmClass: 'btn-danger',
            titleClass: 'text-white', // Classe para o título (azul)
            headerClass: 'bg-danger',
        },
    };

    // Obtém as propriedades da ação atual ou um objeto vazio se a ação não existir
    const { title, body, confirmText, confirmClass, titleClass, headerClass } = actionMessages[action] || {};

    // Se show for false, não renderiza o modal
    if (!show) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className={`modal-header ${headerClass} py-1`}>
                        {/* Aplica a classe dinâmica ao título */}
                        <h6 className={`modal-title ${titleClass} m-0`}>{title}</h6>
                        <button
                          className="btn btn-link text-white p-0 mb-0"
                          onClick={onClose}
                          title="Fechar"
                          style={{ fontSize: '0.9rem', textDecoration: 'none' }}
                        >
                          <i className="bi bi-x-lg"></i>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p>{body}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Cancelar
                        </button>
                        <button type="button" className={`btn ${confirmClass}`} onClick={onConfirm}>
                            {confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConfirmModal;